__turbopack_context__.v({
  "footer": "password-change-successful-card-module-scss-module__bE1iBq__footer",
  "image-container": "password-change-successful-card-module-scss-module__bE1iBq__image-container",
  "info": "password-change-successful-card-module-scss-module__bE1iBq__info",
});
